import React, { useEffect } from 'react';
import { assets } from '../constants/theme';

export default function TwoColumnFeature() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fadeIn');
        }
      });
    }, { threshold: 0.1 });

    const items = document.querySelectorAll('.feature-fade');
    items.forEach((item, idx) => {
      item.style.transitionDelay = `${idx * 0.2}s`;
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  const s = {
    section: {
      padding: '6rem 6%',
      backgroundColor: '#F7F0E6', // cream
    },
    // We rely on index.css .journey-grid and mobile overrides for grid
    container: {
      display: 'grid',
      gap: '4rem',
      maxWidth: '1240px',
      margin: '0 auto',
      width: '100%',
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
    },
    imgContainer: {
      width: '100%',
      aspectRatio: '4/5', 
      overflow: 'hidden',
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    textContainer: {
      padding: '0 1rem', 
    },
    subtitle: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: '#A0693A', // caramel
      marginBottom: '0.5rem',
    },
    title: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '2rem',
      color: '#1C1209', // charcoal
      marginBottom: '1rem',
      lineHeight: 1.2,
    },
    body: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.95rem',
      lineHeight: 1.7,
      color: '#4A2C1A', // bark
    }
  };

  return (
    <section id="feature" style={s.section}>
      <div className="journey-grid" style={s.container}>
        
        {/* Left Column */}
        <div className="feature-fade preFade" style={s.column}>
          <div style={s.imgContainer}>
            <img src={assets.featureLeft} alt="Kenyan coffee farm" style={s.img} loading="lazy" />
          </div>
          <div style={s.textContainer}>
            <div style={s.subtitle}>Origin</div>
            <h3 style={s.title}>Rooted in Kenya</h3>
            <p style={s.body}>
              The rich, volcanic soil and high altitudes of Kenya produce some of the most 
              sought-after coffee profiles in the world for example Arabica A, Arabica B etc. We honor our heritage by working 
              directly with farmers to select the finest beans for our export.
            </p>
          </div>
        </div>

        {/* Right Column */}
        <div className="feature-fade preFade" style={s.column}>
          <div style={s.imgContainer}>
            <img src={assets.featureRight} alt="Grinding and packing" style={s.img} loading="lazy" />
          </div>
          <div style={s.textContainer}>
            <div style={s.subtitle}>Final Touch</div>
            <h3 style={s.title}>Grinding &amp; Roasting</h3>
            <p style={s.body}>
              Whether shipped as green beans or expertly roasted and ground in-house, our 
              focus is precision engineering guarantees consistency. We tailor our roast and 
              grind profiles to meet the exacting standards of our large-scale USA partners.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
